import { Accordion, Box, CheckboxV2 } from '@withjoy/joykit';
import React from 'react';
import { CardFormat } from '../../../../ProductDetailsPage/constants';
import { AccordionTrigger as Trigger } from './FilterShared';
import { CHECKBOX_OVERRIDES } from '../FiltersDrawer.styles';
import { useFormatSearchParam } from '../useFormatSearchParam';
import { useTranslation } from '@shared/core';

const ListCheckBoxItem = ({ isChecked, onChange, label }: { isChecked: boolean; onChange: () => void; label: string }) => {
  return (
    <Box
      as="li"
      minHeight={8}
      display="flex"
    >
      <CheckboxV2
        overrides={CHECKBOX_OVERRIDES}
        width="100%"
        isChecked={isChecked}
        onChange={onChange}
      >
        {label}
      </CheckboxV2>
    </Box>
  );
};

export const FormatFilterAccordionItem = () => {
  const { t } = useTranslation('stationery');
  const tFilterOptions = t('dashboard', 'designsGallery', 'filterOptions');

  const [format, setFormat] = useFormatSearchParam();

  return (
    <Accordion.Item>
      {({ isExpanded }) => {
        return (
          <>
            <Trigger
              onClick={() => {}}
              activeFilterCount={0}
              label={tFilterOptions['format']()}
              isExpanded={isExpanded}
            />

            <Accordion.Panel paddingX={0}>
              <Box
                as="ul"
                display="flex"
                flexDirection="column"
                rowGap={'2px'}
              >
                <ListCheckBoxItem
                  isChecked={format === CardFormat.paper || format === 'all'}
                  onChange={() => setFormat(CardFormat.paper)}
                  label={tFilterOptions['format paper']()}
                />
                <ListCheckBoxItem
                  isChecked={format === CardFormat.premiumDigital || format === 'all'}
                  onChange={() => setFormat(CardFormat.premiumDigital)}
                  label={tFilterOptions['format digital']()}
                />
              </Box>
            </Accordion.Panel>
          </>
        );
      }}
    </Accordion.Item>
  );
};
